import styled, { css } from 'styled-components';
import { border, borderRadius } from 'styled-system';
import { getMediaQuery, themeGet } from '@magalu/stereo-ui-styles';
import Image from '../../../atoms/ResponsiveImage';
import { Box, Flex, Grid, Link, Text } from '../../../atoms';
import LuContentFooter from '../LuContentFooter';
const RoundedTop = css`
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;

  ${getMediaQuery('medium')} {
    border-radius: 4px;
  }
`;
export const Container = styled(Grid).attrs(() => ({
  bg: 'background.luContentPrimary',
  w: 1
}))`
  min-height: 83px;
  ${props => !props.showBackButton && !props.borderRadius && RoundedTop}
  grid-template-columns: 1fr 4fr 1fr;

  ${getMediaQuery('medium')} {
    display: flex;
    align-items: center;
    min-height: 80px;
  }

  ${border}
  ${borderRadius}
`;
export const ArrowBackContainer = styled(Box)`
  margin-top: 14px;
  margin-left: 10px;

  ${getMediaQuery('large')} {
    margin-top: 0;
  }
`;
export const Content = styled(Flex).attrs(() => ({
  pl: [null, null, null, 3]
}))`
  ${getMediaQuery('small')} {
    align-items: flex-end;
    align-self: flex-end;
    width: 100%;
  }
`;
export const LuContentSocialMedias = styled(LuContentFooter)`
  ${getMediaQuery('medium')} {
    margin: 1em ${themeGet('space.3')}px 1em auto;
    min-width: 269px;

    > p {
      display: none;
    }

    > div {
      padding: unset;
    }
  }
`;
export const LuImage = styled(Image)`
  width: 75px;
  max-height: 87px;
  margin-top: -5px;
`;
export const LuExplainContent = styled(Flex).attrs({
  flexDirection: 'column',
  justifyContent: 'center',
  ml: '10px'
})`
  ${getMediaQuery('medium')} {
    align-self: center;
  }
`;
export const LogoLuExplain = styled(Image)`
  ${getMediaQuery('medium')} {
    height: 32px;
    width: auto;
  }
`;
export const Title = styled(Text).attrs(() => ({
  color: 'text.lightest',
  fontWeight: 'bold',
  fontSize: 3,
  lineHeight: 'display',
  forwardedAs: 'h2'
}))`
  text-align: center;
  margin-top: 8px;

  ${props => props.tiny && css`
      font-size: ${themeGet('fontSizes.0')(props)}px;
      text-align: left;
      width: 190px;
      ${getMediaQuery('medium')} {
        font-size: ${themeGet('fontSizes.2')(props)}px;
        width: 100%;
      }
    `}
`;
export const LinkMoreContent = styled(Link).attrs(() => ({
  color: 'text.lightest',
  fontSize: 0
}))`
  margin-top: 10px;
  text-decoration: underline;
`;